var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoOfficialDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1350.69 458.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{fill:url(#linear-gradient-10);}.cls-11{fill:url(#linear-gradient-11);}.cls-12{fill:url(#linear-gradient-12);}.cls-13{fill:url(#linear-gradient-13);}.cls-14{fill:url(#linear-gradient-14);}.cls-15{fill:url(#linear-gradient-15);}.cls-16{fill:url(#linear-gradient-16);}.cls-17{fill:url(#linear-gradient-17);}.cls-18{fill:url(#linear-gradient-18);}.cls-19{fill:url(#linear-gradient-19);}.cls-20{fill:url(#linear-gradient-20);}.cls-21{fill:url(#linear-gradient-21);}.cls-22{fill:url(#linear-gradient-22);}.cls-23{fill:url(#linear-gradient-23);}.cls-24{fill:url(#linear-gradient-24);}.cls-25{fill:url(#linear-gradient-25);}.cls-26{fill:url(#linear-gradient-26);}.cls-27{fill:url(#linear-gradient-27);}.cls-28{fill:url(#linear-gradient-28);}.cls-29{fill:url(#linear-gradient-29);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2112.98,
    y1: 5692.52,
    x2: -2110.49,
    y2: 5685.59,
    gradientTransform: "matrix(11.2, 0, 0, -27.69, 23951.78, 157725.88)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#30c5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025d7d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -2573.01,
    y1: 5692.46,
    x2: -2570.52,
    y2: 5685.53,
    gradientTransform: "matrix(41.47, 0, 0, -40.96, 106868.49, 233345.44)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -2535.59,
    y1: 5689.65,
    x2: -2533.1,
    y2: 5682.72,
    gradientTransform: "matrix(34.46, 0, 0, -37, 87684.02, 210819.59)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -2551.95,
    y1: 5695.65,
    x2: -2549.46,
    y2: 5688.72,
    gradientTransform: "matrix(36.35, 0, 0, -39.04, 92827.43, 222346.5)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -2527.41,
    y1: 5695.19,
    x2: -2524.92,
    y2: 5688.26,
    gradientTransform: "matrix(33.52, 0, 0, -32.52, 85149.44, 185205.31)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -1949.96,
    y1: 5695.31,
    x2: -1947.47,
    y2: 5688.38,
    gradientTransform: "matrix(9.19, 0, 0, -32.5, 18513.48, 185110.65)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -2512.53,
    y1: 5695.51,
    x2: -2510.04,
    y2: 5688.58,
    gradientTransform: "matrix(32.31, 0, 0, -33.81, 81893.3, 192544.83)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -1927.67,
    y1: 5695.31,
    x2: -1925.18,
    y2: 5688.38,
    gradientTransform: "matrix(9.19, 0, 0, -32.5, 18564.97, 185110.65)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -2480.37,
    y1: 5695.53,
    x2: -2477.88,
    y2: 5688.6,
    gradientTransform: "matrix(29.11, 0, 0, -32.5, 73164.78, 185110.65)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -2538.18,
    y1: 5695.02,
    x2: -2535.69,
    y2: 5688.09,
    gradientTransform: "matrix(37.79, 0, 0, -32.5, 96985.62, 185110.65)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -2424.68,
    y1: 5695.09,
    x2: -2422.19,
    y2: 5688.15,
    gradientTransform: "matrix(24.7, 0, 0, -32.5, 61143.43, 185110.65)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -2549.33,
    y1: 5689.82,
    x2: -2546.84,
    y2: 5682.89,
    gradientTransform: "matrix(37.79, 0, 0, -32.5, 96879.61, 185153.12)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -2519.77,
    y1: 5690,
    x2: -2517.28,
    y2: 5683.06,
    gradientTransform: "matrix(33.52, 0, 0, -32.52, 85216.43, 185247.87)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -2540.21,
    y1: 5690.1,
    x2: -2537.72,
    y2: 5683.17,
    gradientTransform: "matrix(37.8, 0, 0, -32.5, 96978.28, 185158.86)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -1902.74,
    y1: 5690.11,
    x2: -1900.25,
    y2: 5683.18,
    gradientTransform: "matrix(9.19, 0, 0, -32.5, 18625.45, 185153.12)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -2488.22,
    y1: 5690.11,
    x2: -2485.73,
    y2: 5683.18,
    gradientTransform: "matrix(30.92, 0, 0, -32.5, 78189.1, 185153.12)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -1569.69,
    y1: 5643.92,
    x2: -1567.2,
    y2: 5636.98,
    gradientTransform: "matrix(6.16, 0, 0, -7.18, 10181.67, 40942.1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -1626.13,
    y1: 5644.79,
    x2: -1623.64,
    y2: 5637.86,
    gradientTransform: "matrix(6.51, 0, 0, -7.32, 11172.4, 41728.13)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -1605.16,
    y1: 5643.67,
    x2: -1602.67,
    y2: 5636.74,
    gradientTransform: "matrix(6.44, 0, 0, -7.19, 10981.35, 41007.98)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -1632.39,
    y1: 5643.69,
    x2: -1629.9,
    y2: 5636.76,
    gradientTransform: "matrix(6.65, 0, 0, -7.18, 11567.66, 40942.1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1234.99,
    y1: 5643.69,
    x2: 1237.48,
    y2: 5636.76,
    gradientTransform: "matrix(1.87, 0, 0, -7.18, -1495.93, 40942.1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -1523.25,
    y1: 5643.92,
    x2: -1520.76,
    y2: 5636.98,
    gradientTransform: "matrix(6.16, 0, 0, -7.18, 10253.53, 40942.1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -1644.72,
    y1: 5643.61,
    x2: -1642.23,
    y2: 5636.68,
    gradientTransform: "matrix(6.91, 0, 0, -7.18, 12347.7, 40969.04)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 1329,
    y1: 5643.69,
    x2: 1331.49,
    y2: 5636.76,
    gradientTransform: "matrix(1.87, 0, 0, -7.18, -1451.66, 40942.1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -1631.8,
    y1: 5645.62,
    x2: -1629.31,
    y2: 5638.69,
    gradientTransform: "matrix(6.92, 0, 0, -7.43, 12384.7, 42364.88)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1378.22,
    y1: 5643.69,
    x2: 1380.71,
    y2: 5636.76,
    gradientTransform: "matrix(1.87, 0, 0, -7.18, -1428.48, 40942.1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -1479.66,
    y1: 5643.92,
    x2: -1477.17,
    y2: 5636.98,
    gradientTransform: "matrix(6.16, 0, 0, -7.18, 10320.99, 40942.1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -1767.91,
    y1: 5643.43,
    x2: -1765.42,
    y2: 5636.5,
    gradientTransform: "matrix(8.02, 0, 0, -7.18, 15443.71, 40959.13)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -1142.55,
    y1: 5643.47,
    x2: -1140.06,
    y2: 5636.54,
    gradientTransform: "matrix(4.92, 0, 0, -7.18, 6951.72, 40942.1)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard_14",
    "data-name": "Artboard 14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67-5",
    "data-name": "Group 67-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65-5",
    "data-name": "Group 65-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39-5",
    "data-name": "Group 39-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33-5",
    "data-name": "Path 33-5",
    className: "cls-1",
    d: "M318.39,234V96.16H262.63v64.67C279.56,173.67,302.69,206,318.39,234Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34-5",
    "data-name": "Path 34-5",
    className: "cls-2",
    d: "M273.29,193.08h0a96.66,96.66,0,0,0-24.76-19.19c-9.65-5.82-32.23-10.25-47.14-10.25a88.34,88.34,0,0,0-33.74,6.6,81,81,0,0,0-28.42,19.62,99.27,99.27,0,0,0-19.8,31.91,116.75,116.75,0,0,0-7.52,43.46V266a116.62,116.62,0,0,0,7.52,43.46,97.52,97.52,0,0,0,20,31.9A82.45,82.45,0,0,0,168,360.94a87.16,87.16,0,0,0,33.36,6.6,68.47,68.47,0,0,0,36.48-8.91,88.22,88.22,0,0,0,24.76-22.74,28,28,0,0,0,28,28h27.75V339.74c0-52.55-7.63-103.39-42-143.14Q274.87,194.83,273.29,193.08ZM263.37,266a62.58,62.58,0,0,1-3.85,22.34,55.1,55.1,0,0,1-10.27,17.35,45.46,45.46,0,0,1-52.07,11.08A46.2,46.2,0,0,1,182,305.64a53.22,53.22,0,0,1-10.45-17.35A62.36,62.36,0,0,1,167.66,266v-.73a62,62,0,0,1,3.85-22.52A53.78,53.78,0,0,1,182,225.53a46,46,0,0,1,15.22-11.07,44.86,44.86,0,0,1,52.07,11.07,55.33,55.33,0,0,1,10.27,17.35,62.58,62.58,0,0,1,3.85,22.34Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_35-15",
    "data-name": "Path 35-15",
    className: "cls-3",
    d: "M379.8,274.7V405.42H261.74v53.52H433.3V274.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35-16",
    "data-name": "Path 35-16",
    className: "cls-4",
    d: "M56.43,194.37v-47a91,91,0,0,1,91-90.95H181V0H147.39A147.56,147.56,0,0,0,0,147.39v47Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68-3",
    "data-name": "Group 68-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36-3",
    "data-name": "Group 36-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8-3",
    "data-name": "Path 8-3",
    className: "cls-5",
    d: "M380.94,4h76.52a107.17,107.17,0,0,1,47.16,10,74.94,74.94,0,0,1,31.91,28.21,86.43,86.43,0,0,1,0,85.54,74.94,74.94,0,0,1-31.91,28.21,107,107,0,0,1-47.16,9.95H380.94Zm74.69,125.31A47,47,0,0,0,489,117.47a48.47,48.47,0,0,0,0-65.2,46.92,46.92,0,0,0-33.41-11.78H426.75v88.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9-3",
    "data-name": "Path 9-3",
    className: "cls-6",
    d: "M571.9,4h45.77V165.78H571.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10-3",
    "data-name": "Path 10-3",
    className: "cls-7",
    d: "M758.7,81.4h40.45v67a105.43,105.43,0,0,1-31.9,15.25A127,127,0,0,1,731.18,169a96.35,96.35,0,0,1-45.77-10.75,80.19,80.19,0,0,1-31.9-29.93,87.51,87.51,0,0,1,0-86.93,79.8,79.8,0,0,1,32.13-29.94A98.94,98.94,0,0,1,732.11.72,103.68,103.68,0,0,1,772.8,8.35a78.59,78.59,0,0,1,30.05,22L773.72,56.67a51.34,51.34,0,0,0-39.3-18,43.52,43.52,0,0,0-46.24,46.24A48.8,48.8,0,0,0,694,108.81a41.47,41.47,0,0,0,16.19,16.43A47.36,47.36,0,0,0,734,131.13a58.36,58.36,0,0,0,24.74-5.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11-3",
    "data-name": "Path 11-3",
    className: "cls-8",
    d: "M828.28,4h45.77V165.78H828.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12-3",
    "data-name": "Path 12-3",
    className: "cls-9",
    d: "M941.1,40.25H891.39V4h144.95v36.3H986.87V165.78H941.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13-3",
    "data-name": "Path 13-3",
    className: "cls-10",
    d: "M1153.79,134.34h-68.43l-12.71,31.44H1026L1097.38,4h45.08l71.67,161.82h-47.62Zm-13.41-33.75L1119.57,48.8l-20.81,51.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14-3",
    "data-name": "Path 14-3",
    className: "cls-11",
    d: "M1227.07,4h45.77V129.49h77.22v36.29h-123Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15-3",
    "data-name": "Path 15-3",
    className: "cls-12",
    d: "M626.36,345.8H557.93l-12.72,31.44h-46.7L570,215.42H615L686.7,377.24H639.07ZM613,312.05l-20.81-51.78-20.81,51.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16-3",
    "data-name": "Path 16-3",
    className: "cls-13",
    d: "M701.57,215.41H778.1a107.2,107.2,0,0,1,47.16,10,74.91,74.91,0,0,1,31.9,28.21,86.38,86.38,0,0,1,0,85.54,74.91,74.91,0,0,1-31.9,28.21,107.19,107.19,0,0,1-47.16,9.95H701.57Zm74.69,125.31a47,47,0,0,0,33.41-11.79,48.47,48.47,0,0,0,0-65.2,46.92,46.92,0,0,0-33.41-11.79H747.38v88.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17-3",
    "data-name": "Path 17-3",
    className: "cls-14",
    d: "M1040.59,377.24l-.46-85.76L998.52,361.3H978.17l-41.38-67.51v83.45H894.47V215.42h37.68L989,308.81l55.51-93.4h37.69l.47,161.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18-3",
    "data-name": "Path 18-3",
    className: "cls-15",
    d: "M1116.13,215.41h45.78V377.24h-45.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19-3",
    "data-name": "Path 19-3",
    className: "cls-16",
    d: "M1350,215.41V377.24h-37.68L1240.87,291v86.23H1196V215.41h37.69l71.43,86.23V215.41Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37-3",
    "data-name": "Group 37-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20-3",
    "data-name": "Path 20-3",
    className: "cls-17",
    d: "M501.21,418.21h30.66v7.71H521.16v28h-9.34V425.9H501.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21-3",
    "data-name": "Path 21-3",
    className: "cls-18",
    d: "M577,444.64a6.73,6.73,0,0,0,5,2,6.32,6.32,0,0,0,4.87-2,7.65,7.65,0,0,0,1.86-5.43V418.21h9.34v21a16.24,16.24,0,0,1-2,8.13,13.29,13.29,0,0,1-5.61,5.38,18.37,18.37,0,0,1-8.55,1.9,18.73,18.73,0,0,1-8.6-1.9,13.53,13.53,0,0,1-5.71-5.38,15.94,15.94,0,0,1-2-8.13v-21H575v21A7.37,7.37,0,0,0,577,444.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22-3",
    "data-name": "Path 22-3",
    className: "cls-19",
    d: "M656.57,454l-5.2-9.89h-6.94V454h-9.34V418.21h16.07a16.59,16.59,0,0,1,11,3.29,11.45,11.45,0,0,1,3.9,9.27,14.12,14.12,0,0,1-1.63,7,11.29,11.29,0,0,1-4.74,4.57L667.16,454Zm-12.14-17.34h6.78a6.3,6.3,0,0,0,4.41-1.43,5.3,5.3,0,0,0,1.56-4.14,5.09,5.09,0,0,0-1.56-4,6.38,6.38,0,0,0-4.41-1.4h-6.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23-3",
    "data-name": "Path 23-3",
    className: "cls-20",
    d: "M727.08,418.21h8.67V454h-8.16l-16.22-21.37V454h-8.73V418.21h8.21l16.28,21.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24-3",
    "data-name": "Path 24-3",
    className: "cls-21",
    d: "M815.29,418.21h9.33V454h-9.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25-3",
    "data-name": "Path 25-3",
    className: "cls-22",
    d: "M859.05,418.21h30.66v7.71H879v28h-9.33V425.9H859.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26-3",
    "data-name": "Path 26-3",
    className: "cls-23",
    d: "M991.38,420.46a16.42,16.42,0,0,1,6.71,6.3,19.26,19.26,0,0,1,0,18.65,16.42,16.42,0,0,1-6.84,6.32A21.94,21.94,0,0,1,981.12,454h-15V418.21h15.38A21.11,21.11,0,0,1,991.38,420.46Zm-4.87,24.69a8.7,8.7,0,0,0,3.26-3.62,11.85,11.85,0,0,0,1.18-5.36,11.29,11.29,0,0,0-1.25-5.41,9.18,9.18,0,0,0-3.45-3.65,9.65,9.65,0,0,0-5-1.3H975.4v20.61h6.33a9,9,0,0,0,4.78-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27-3",
    "data-name": "Path 27-3",
    className: "cls-24",
    d: "M1035.75,418.21h9.33V454h-9.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28-3",
    "data-name": "Path 28-3",
    className: "cls-25",
    d: "M1106.31,435.71h8.06V450a24.19,24.19,0,0,1-7,3.39,26.77,26.77,0,0,1-7.89,1.3,19.83,19.83,0,0,1-9.77-2.43,18,18,0,0,1-6.86-6.66,18.24,18.24,0,0,1-2.49-9.49,17.67,17.67,0,0,1,2.58-9.41,18.08,18.08,0,0,1,7.09-6.6,21,21,0,0,1,10.08-2.4,23.08,23.08,0,0,1,8,1.45,20.74,20.74,0,0,1,6.73,3.9l-5.31,6.53a15,15,0,0,0-4.48-2.91,12.73,12.73,0,0,0-5-1.07,9.82,9.82,0,0,0-8.75,5.16,10.78,10.78,0,0,0-1.33,5.35,11.09,11.09,0,0,0,1.33,5.44,9.78,9.78,0,0,0,3.67,3.8,10.13,10.13,0,0,0,5.2,1.38,14.1,14.1,0,0,0,6.18-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29-3",
    "data-name": "Path 29-3",
    className: "cls-26",
    d: "M1151.16,418.21h9.33V454h-9.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-3",
    "data-name": "Path 30-3",
    className: "cls-27",
    d: "M1194.92,418.21h30.67v7.71h-10.72v28h-9.34V425.9h-10.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31-3",
    "data-name": "Path 31-3",
    className: "cls-28",
    d: "M1282.42,454l-2.45-6.32h-15.43l-2.49,6.32h-9.6l15.36-35.76h9.59l15,35.76Zm-15.09-13.44h9.9l-4.9-12.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32-3",
    "data-name": "Path 32-3",
    className: "cls-29",
    d: "M1326.2,418.21h9.34V446h15.15v8H1326.2Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOfficialDark);
export default __webpack_public_path__ + "static/media/logo-official-dark.d717c8f63191133de80347972b980dbb.svg";
export { ForwardRef as ReactComponent };